import i18n from 'modules/core/lib/i18n'

import ListPopoverItem from './ListPopoverItem'
import usePlannedTimes from './usePlannedTimes'

type Props = {
  plannedClockIn: string
  plannedClockOut: string
  employeeTimezone: string
}

const PlannedTimes = ({ plannedClockIn, plannedClockOut, employeeTimezone }: Props) => {
  const { plannedClockInFormatted, plannedClockOutFormatted } = usePlannedTimes(
    plannedClockIn,
    plannedClockOut
  )

  return (
    <>
      <ListPopoverItem
        term={i18n.t('dashboard.who_is_in.tooltip.planned_shift')}
        details={`${plannedClockInFormatted} - ${plannedClockOutFormatted}`}
      />
      <ListPopoverItem
        term={i18n.t('dashboard.who_is_in.tooltip.timezone')}
        details={employeeTimezone}
      />
    </>
  )
}

export default PlannedTimes
